<template>
  <div>
    <div class="row">
      <div class="col text-left">
        <div class="alert alert-dark" v-if="idCopiado !== ''">
          <strong>Id copiado</strong> {{ idCopiado }}
        </div>
      </div>
    </div>
    <div
      v-if="tab && itens.length > 0"
      class="d-flex justify-content-start"
      style="margin-bottom: 5px"
      role="group"
      aria-label="Basic example"
    >
      <button
        type="button"
        style="margin-right: 5px; zoom: 0.7"
        class="btn btn-sm btn-light"
        @click="selecionarTodos()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-check-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
          <path
            d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
          />
        </svg>
      </button>
      <button
        type="button"
        style="margin-right: 5px; zoom: 0.7"
        class="btn btn-sm btn-light"
        @click="limparSelecionados(true)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
        </svg>
      </button>
    </div>
    <div
      class="list-group-item"
      v-for="item in itens"
      :key="item.id"
      :item="item"
    >
      <div class="row">
        <div class="col text-left">
          <div>
            <div class="d-flex justify-content-between">
              <h6 style="margin-top: 2px">
                <small v-if="retornaSite() !== 'Share'">
                  {{ item.dataHora.toString().padStart(2, "0") }}:{{
                    item.dataMinuto.toString().padStart(2, "0")
                  }}
                  -
                </small>
                {{ item.nome }}
              </h6>
              <h6
                v-if="retornaSite() !== 'Share'"
                @click="alterarListViewFuncoes(item)"
                :class="{
                  'cursor-pointer':
                    retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp',
                }"
              >
                <small
                  v-if="
                    retornaSite() == 'Weddbets' &&
                    item.usuarioCriacaoJoin &&
                    item.usuarioCriacaoJoin.length > 0
                  "
                  >{{ item.usuarioCriacaoJoin[0].nome }} / </small
                ><small>{{ situacao[item.situacao] }}</small
                ><small
                  v-if="
                    $global.servidores_sip()[
                      item.servidorTipo + '_' + item.servidor
                    ]
                  "
                  class="text-success"
                >
                  /
                  {{
                    $global.servidores_sip()[
                      item.servidorTipo + "_" + item.servidor
                    ].nome
                  }}
                  <span
                    v-if="
                      retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp'
                    "
                    >({{ item.canais }})</span
                  ></small
                >
              </h6>
              <h6
                v-if="
                  retornaSite() == 'Share' &&
                  item.usuarioCriacaoJoin &&
                  item.usuarioCriacaoJoin.length > 0
                "
              >
                <small>{{ item.usuarioCriacaoJoin[0].email }}</small>
              </h6>
            </div>

            <div class="d-flex justify-content-between">
              <div
                class="d-flex justify-content-start"
                v-if="retornaSite() !== 'Share'"
              >
                <input
                  @change="$emit('selecionar', $event, item)"
                  type="checkbox"
                  style="
                    margin-left: 10px;
                    margin-right: 18px;
                    margin-top: 5px;
                    transform: scale(1.3);
                    -webkit-transform: scale(1.3);
                  "
                  v-model="item.selecionado"
                />
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="{
                    'btn-outline-dark': !item.sofaScoreId,
                    'btn-dark': item.sofaScoreId,
                  }"
                  style="
                    margin-right: 10px;
                    font-size: 9px;
                    padding-top: 1px;
                    padding-bottom: 0px;
                    padding-left: 4px;
                    padding-right: 4px;
                  "
                  data-target="#dialogEdit"
                  data-toggle="modal"
                  @click="$emit('editarItem', item._id)"
                >
                  SOFA
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="{
                    'btn-outline-dark': !item.williamHillId,
                    'btn-dark': item.williamHillId,
                  }"
                  style="
                    margin-right: 10px;
                    font-size: 9px;
                    padding-top: 1px;
                    padding-bottom: 0px;
                    padding-left: 4px;
                    padding-right: 4px;
                  "
                  @click="$emit('williamhillVincular', item._id)"
                >
                  WILL
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="{
                    'btn-outline-dark':
                      item.usuarioCriacaoJoin[0]._id !== idUsuario,
                    'btn-dark': item.usuarioCriacaoJoin[0]._id == idUsuario,
                  }"
                  style="
                    margin-right: 10px;
                    padding-top: 1px;
                    padding-bottom: 0px;
                    padding-left: 4px;
                    padding-right: 4px;
                  "
                  data-target="#dialogEdit"
                  data-toggle="modal"
                  @click="$emit('editarItem', item._id)"
                  v-if="
                    item.usuarioCriacaoJoin &&
                    item.usuarioCriacaoJoin.length > 0 &&
                    retornaSite() == '7live'
                  "
                >
                  {{ item.usuarioCriacaoJoin[0].nome }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  style="
                    margin-right: 10px;
                    font-size: 9px;
                    padding-top: 1px;
                    padding-bottom: 0px;
                    padding-left: 4px;
                    padding-right: 4px;
                  "
                  @click="$emit('aoVivo', item._id)"
                  v-if="item.situacao == 1"
                >
                  AO VIVO
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  style="
                    margin-right: 10px;
                    font-size: 9px;
                    padding-top: 1px;
                    padding-bottom: 0px;
                    padding-left: 4px;
                    padding-right: 4px;
                  "
                  @click="$emit('encerrar', item._id)"
                  v-if="item.situacao == 3"
                >
                  Encerrar
                </button>
              </div>
              <div>
                <div
                  :class="{
                    'd-none':
                      listViewFuncoes[item._id] &&
                      listViewFuncoes[item._id] !== 'normal',
                  }"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="margin-right: 10px; zoom: 0.7"
                    data-target="#dialogEdit"
                    data-toggle="modal"
                    @click="$emit('editarItem', item._id)"
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="margin-right: 10px; zoom: 0.7"
                    @click="$emit('transmitItem', item._id)"
                  >
                    Transmitir
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="margin-right: 10px; zoom: 0.7; display: none"
                    @click="$emit('fonteItem', item.linkFonte)"
                    v-if="retornaSite() !== 'ShareApp'"
                  >
                    Fonte
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="margin-right: 10px; zoom: 0.7"
                    @click="$emit('excluirItem', item)"
                  >
                    Excluir
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="zoom: 0.7"
                    @click="copyId(item._id)"
                    v-if="retornaSite() !== '7live'"
                  >
                    Id
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    style="zoom: 0.7"
                    @click="abrirEvento(item)"
                    v-if="retornaSite() == '7live'"
                  >
                    Player
                  </button>
                </div>
                <div
                  :class="{
                    'd-none':
                      !listViewFuncoes[item._id] ||
                      listViewFuncoes[item._id] !== 'player',
                  }"
                >
                  <div
                    class="d-flex"
                    v-if="
                      retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp'
                    "
                  >
                    <div
                      v-for="(canal, keyCanal) in [
                        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                        17, 18, 19, 20, 21,
                      ]"
                      :key="keyCanal"
                      :item="canal"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        style="zoom: 0.7; min-width: 30px"
                        :class="{ 'mr-2': keyCanal != 20 }"
                        @click="abrirEventoPlayer(item, keyCanal)"
                      >
                        {{ keyCanal }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListEventos",
  components: {},
  props: { itens: Array, tab: { type: Boolean, default: false } },
  methods: {
    retornaSite() {
      return this.$site;
    },
    limparSelecionados(emit) {
      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        if (this.itens[indiceItem].selecionado == true) {
          this.$set(this.itens[indiceItem], "selecionado", false);

          if (emit) {
            this.$emit("selecionar", {}, this.itens[indiceItem]);
          }
        }
      }
    },
    selecionarTodos() {
      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        if (this.itens[indiceItem].selecionado == false) {
          this.$set(this.itens[indiceItem], "selecionado", true);
          this.$emit("selecionar", {}, this.itens[indiceItem]);
        }
      }
    },
    copyId(texto) {
      var call = this;
      this.$copyText(texto).then(
        function (e) {
          call.idCopiado = texto;
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },
    abrirEvento(evento) {
      window.open(
        "/view/" + evento._id + "?view=clean",
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    abrirEventoPlayer(evento, canal) {
      window.open(
        "/view/" + evento._id + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    alterarListViewFuncoes(item) {
      if (
        this.retornaSite() !== "Weddbets" &&
        this.retornaSite() !== "ShareApp"
      ) {
        return;
      }

      if (
        !this.listViewFuncoes[item._id] ||
        this.listViewFuncoes[item._id] == "normal"
      ) {
        this.listViewFuncoes[item._id] = "player";
      } else if (this.listViewFuncoes[item._id] == "player") {
        this.listViewFuncoes[item._id] = "normal";
      }

      this.$forceUpdate();
    },
  },
  computed: {
    idUsuario: function () {
      return this.$sessao.usuario._id;
    },
  },
  mounted() {},
  data: function () {
    return {
      situacao: {
        1: "Previsto",
        2: "Invisivel",
        3: "Ao Vivo",
        4: "Finalizado",
      },
      idCopiado: "",
      listViewFuncoes: {},
    };
  },
};
</script>

<style>
</style>
